<template>
	<input type="checkbox"
		   v-model="inputValue"
		   :id="id"
		   :name="name"
		   :class="inputClassListLive"
		   :required="requiredLive"
		   :readonly="readonlyLive"
		   :disabled="disabledLive"

		   @input="onInputHandler"
		   @change="onChangeHandler"
		   @focus="onFocusHandler"
		   @blur="onBlurHandler"
	>
</template>

<script>
	import { baseInput } from './../mixins/index.js';

	export default {
		name: 'CheckboxInput',

		mixins: [baseInput],

		created() {
			this.inputValue = !!this.value;
		},
	};
</script>
